import { get } from "./config";
import { getApiUrl } from "./api-config";
import { toAnalyticsUtcPeriod } from "../utils/analyticsPeriod";

const tools = new Set([
  "orders-by-tender-type",
  "company-info",
  "orders-overview",
  "route-analytics",
  "fastest-responding-companies",
]);

export async function getAssistantTool(request, { startDate, endDate, signal }) {
  if (!tools.has(request.tool) || (request.tool === "company-info" && !request.companyName?.trim())) {
    throw new Error("Invalid assistant request");
  }
  const period = toAnalyticsUtcPeriod({ startDate, endDate });
  const { data } = await get(request.tool, {
    baseURL: getApiUrl("v1/ai-service/Assistant/tools/"),
    params: {
      from: period.startDate,
      to: period.endDate,
      ...(request.tool === "company-info" ? { companyName: request.companyName.trim() } : {}),
    },
    signal,
    timeout: 30000,
  });
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    throw new Error("Invalid assistant response");
  }
  if (
    (request.tool === "route-analytics" && !Array.isArray(data.routes)) ||
    (request.tool === "fastest-responding-companies" && !Array.isArray(data.ranking))
  ) {
    throw new Error("Invalid assistant response");
  }
  return data;
}
